import type { ReactNode } from "react";

import { UserAvatar } from "@/components/UserAvatar";
import { Text } from "@/components/ui/text";
import { format } from "@/lib/utils";
import type { TestRunDetails } from "../types";
import { TestRunCard } from "./TestRunCard";

interface TestRunDetailProps {
  run: TestRunDetails;
}

function DetailItem({
  children,
  title,
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col">
      <Text size="1" muted>
        {title}
      </Text>
      <Text className="flex items-center gap-1">{children}</Text>
    </div>
  );
}

export function TestRunDetail({ run }: TestRunDetailProps) {
  return (
    <TestRunCard>
      <div className="flex flex-col gap-3">
        <DetailItem title="Date">{format(run.createdAt)}</DetailItem>
        <DetailItem title="Description">{run.description || "-"}</DetailItem>
        <DetailItem title="Lab">
          {run.labs?.length ? run.labs.map((l) => l.name).join(", ") : "-"}
        </DetailItem>
        <DetailItem title="Created by">
          <UserAvatar size="small" user={run.createdBy} />
          <span>{run.createdBy?.username || "-"}</span>
        </DetailItem>
      </div>
    </TestRunCard>
  );
}
